import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DateTime } from "luxon";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import Autocomplete from '@mui/material/Autocomplete';

import { styled, } from "@mui/styles";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

// APIS
import getAllRecruitmentPartnersAndClients from "../../apis/getAllRecruitmentPartnersAndClients";
import { getAllAgency } from "../../apis/agency/agencyApi.js";
import { getAgencyType } from "../../apis/agency/agencyApi.js";
import { updateAgencyById } from "../../apis/agency/agencyApi.js";
import { createNewAgency } from "../../apis/agency/agencyApi.js";
import DataTable from "../../components/DataTable/DataTable";
import DatePicker from "react-datepicker";

// Styled DialogContent
const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  // padding: '0px 30px 0px 30px', // Uncomment or adjust if needed
}));

// Styled DialogActions
const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 0,
  padding: '16px',
}));

// Functional Component
const AgencyKendo = ({openModal,setOpenModal}) => {
  const [modalIsOpenEdit, setModalIsOpenEdit] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]

  // My state for Agency
  const [allData, setAllData] = useState([]);
  const [recruiterData, setRecruiterData] = useState([]);

  // State for Adding
  const [agencyInfo, setAgencyInfo] = useState({
    recruitmentPartnerArr: "",
    isActive: "",
    agencyName: "",
    selectedAgencyType: {},
    recPartners: "",
    agencyId: "",

  })
  const [agencyTypeOptions, setAgencyTypeOptions] = useState([]);

  // Options for active and agency type
  const isActiveItems = ["True", "False"];
  const getUserID = localStorage.getItem("userID");
  const [atvBtn, setAtvBtn] = useState(false);

  //----------------------------------
  const clearData = () => {
    setAgencyInfo({
      recruitmentPartnerArr: "",
      isActive: "",
      agencyName: "",
      selectedAgencyType: {},
      recPartners: "",
    })
  };

  const handleisActive = (e, value) => {
    if (value === "True") {
      setAgencyInfo({ ...agencyInfo, isActive: true })
    } else if (value === "False") {
      setAgencyInfo({ ...agencyInfo, isActive: false })
    } else {
      setAgencyInfo({ ...agencyInfo, isActive: null })
    }
  };

  const handleAgencytype = (e, value) => {
    if (value) {
      setAgencyInfo({ ...agencyInfo, selectedAgencyType: value })
    } else {
      setAgencyInfo({ ...agencyInfo, selectedAgencyType: {} })
    }
  };



  const handleRecruiterName = (e, value) => {
    setAgencyInfo({ ...agencyInfo, recruitmentPartnerArr: value?.id })
  };

  const handleName = (e) => {
    setAgencyInfo({ ...agencyInfo, agencyName: e.target.value?.trim() })
  };


  // Edit Action Handler
  const handleEditClick = async (e) => {
    setModalIsOpenEdit((prev) => (prev = true));
    const selectedAgency = agencyTypeOptions.find(a => a.id === e.agencyTypeId);
    setAgencyInfo({
      ...agencyInfo, agencyId: e?.id, agencyName: e.agencyName?.trim(), selectedAgencyType: selectedAgency, recPartners:
        e?.recruitmentpartner, isActive: e?.isActive, recruitmentPartnerArr: e?.recruitmentpartner
    })
  };

  const handleRecruitmentPartnersClick = (e, value) => {
    setAgencyInfo({ ...agencyInfo, recruitmentPartnerArr: value?.id })
  };

  const validateBoolean = (booleanValue) => {
    let active;
    if (booleanValue === "True") {
      active = true;
    } else if (booleanValue === true) {
      active = true;
    } else if (booleanValue === "False") {
      active = false;
    } else if (booleanValue === false) {
      active = false;
    } else {
      active = null;
    }
    return active;
  };


  // Adding agency handler
  const createAgency = async () => {
    setAtvBtn(true)
    let active = validateBoolean(agencyInfo.isActive);

    // Payload
    let agencyData = {
      agencyName: agencyInfo.agencyName?.trim(),
      agencyTypeId: agencyInfo.selectedAgencyType.id,
      recruitmentOrganizationId: agencyInfo.recruitmentPartnerArr,
      isActive: active,
      createdBy: getUserID,
      updatedBy: getUserID,
    };

    // Validating
    if (agencyData.agencyName?.trim().toLowerCase() === "null") {
      setAtvBtn(false)
      return NotificationManager.error(
        "Please enter valid Agency Name.",
        "Error",
        10000
      );
    }

    if (
      !agencyData.recruitmentOrganizationId ||
      !agencyData.agencyName ||
      !agencyData.agencyTypeId ||
      agencyData.isActive === undefined ||
      agencyData.isActive === "" ||
      agencyData.isActive === null
    ) {
      setAtvBtn(false)
      return NotificationManager.error(
        "Please fill all the mandatory fields.",
        "Error",
        10000
      );
    } else {
      try {
        const agencyResponse = await createNewAgency(agencyData);
        getData();

        // If Agency already exist
        if (
          agencyResponse?.data?.message ===
          "This Agency name already exists Please use a different Agency name"
        ) {
          setAtvBtn(false)
          NotificationManager.error(
            "This Agency name already exists. Please use a different Agency name.",
            "Error",
            10000
          );
        } else {
          NotificationManager.success(
            "Agency added successfully.",
            "Success",
            10000
          );
          clearData();
          setOpenModal(false);
          setAtvBtn(false)
        }
        setAtvBtn(false)

      } catch (error) {
        console.log(error);
        getData();
        setAtvBtn(false)
      }
    }
  };

  // Edit agency handler
  const editAgency = async () => {
    setAtvBtn(true)
    let active = validateBoolean(agencyInfo.isActive);

    // Payload
    let agencyData = {
      agencyName: agencyInfo.agencyName?.trim(),
      agencyTypeId: agencyInfo.selectedAgencyType.id,
      recruitmentOrganizationId: agencyInfo.recruitmentPartnerArr.id,
      isActive: active,
      createdBy: getUserID,
      updatedBy: getUserID,
    };

    // Validating
    if (agencyData.agencyName?.trim().toLowerCase() === "null") {
      setAtvBtn(false)
      return NotificationManager.error(
        "Please enter valid Agency Name.",
        "Error",
        10000
      );
    }

    if (
      !agencyData.recruitmentOrganizationId ||
      !agencyData.agencyName ||
      !agencyData.agencyTypeId ||
      agencyData.isActive === undefined ||
      agencyData.isActive === "" ||
      agencyData.isActive === null
    ) {
      setAtvBtn(false)
      return NotificationManager.error(
        "Please fill all the mandatory fields.",
        "Error",
        10000
      );
    } else {
      try {
        const agencyResponse = await updateAgencyById(agencyInfo.agencyId, agencyData);
        getData();
        if (
          agencyResponse?.data?.message ===
          "This Recruitment organization name already exists Please use a different Recruitment organization name"
        ) {
          setAtvBtn(false)
          NotificationManager.error(
            "This Recruitment organization name already exists. Please use a different Recruitment organization name.",
            "Error",
            10000
          );
        } else {
          NotificationManager.success(
            "Agency updated successfully.",
            "Success",
            10000
          );

          handleClosed();
          clearData();
          setAtvBtn(false)
        }
      } catch (error) {
        console.log(error);
        setAtvBtn(false)
      }
    }
  };


  const getData = async () => {
    // Getting all agency data
    setIsDataLoaded(false);
    const agencyData = await getAllAgency();
    const allAgencyData = agencyData?.data?.data;

    // Getting agencyType data
    const agencyType = await getAgencyType();
    const agencyTypeData = agencyType?.data?.data;

    setAgencyTypeOptions(agencyTypeData);

    for (let i = 0; i < allAgencyData.length; i++) {
      // Recruitment partner name
      let recruitmentPartnerObj = allAgencyData[i]?.recruitmentpartner;
      allAgencyData[i].recruitmentsPartner = recruitmentPartnerObj?.name;

      // Agency type
      let agencyTypeValue = allAgencyData[i]?.agencyType?.code[0].toUpperCase() + allAgencyData[i]?.agencyType?.code.slice(1);
      allAgencyData[i].agencyType = agencyTypeValue;

      // Created Date
      let date = allAgencyData[i]?.createdAt;
      let convertedDate = DateTime.fromISO(date)
        .toLocal()
        .startOf("day")
        .toJSDate();
      allAgencyData[i].createdTime = convertedDate;
    }

    setAllData(allAgencyData);

    // Recruitment Partner api call for getting all recruitment partner name
    let data = await getAllRecruitmentPartnersAndClients();
    let allDataSet = data?.data?.data;

    setRecruiterData(allDataSet.filter((item) => item?.isActive === true));
    setIsDataLoaded(true);

  };

  const handleClosed = () => {
    setModalIsOpenEdit((prev) => (prev = false));
  };

  function dateFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.original.createdAt;
    if (!rowValue) return false;

    try {
      const rowDate = new Date(rowValue);
      const filterDate = new Date(filterValue);

      // Reset time to start of day for both dates to compare only date part
      rowDate.setHours(0, 0, 0, 0);
      filterDate.setHours(0, 0, 0, 0);

      return rowDate.getTime() === filterDate.getTime();
    } catch (error) {
      console.warn('Date filtering error:', error);
      return false;
    }
  }

  const getDateFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    return filterValue ? new Date(filterValue) : null;
  }

  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  const columns = [
    {
      accessorKey: 'Action',
      header: 'Action',
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <Button
          onClick={(e) =>
            handleEditClick(row.original)
          }
          variant="contained"
          color="primary"
        >
          Edit
        </Button>
      ),
      size: 100,
    },
    {
      accessorKey: 'agencyName',
      header: 'Name',
      enableColumnFilter: true,
      enableSorting: true,
      size: 200
    },
    {
      accessorKey: 'recruitmentsPartner',
      header: 'Recruitment Organization',
      enableColumnFilter: true,
      enableSorting: true,
      size: 230
    },
    {
      accessorKey: 'agencyType',
      header: 'Agency Type',
      enableColumnFilter: true,
      enableSorting: true,
      size: 200
    },
    {
      accessorKey: 'createdTime',
      header: 'Created At',
      size: 235,
      filterFn: dateFilterFn,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              column.setFilterValue(date ? date.toISOString() : '');
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            maxDate={new Date()}
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (
        <>
          {DateTime.fromISO(row.original.createdAt)
            .toFormat("MM/dd/yyyy")
            .toString()}
        </>
      )
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 100,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },

  ]

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="containerMain_recPartnersAndClients">
        <DataTable
          data={allData}
          columns={columns}
          isLoading={!isDataLoaded}
          className="table_recPartnersAndClients"
          initialColumnFilters={[
            {
              id: 'isActive',
              value: 'true'
            }
          ]}
        />
      </div>

      {/* Add Agency */}
      <Dialog
        onClose={() => setOpenModal(false)}
        aria-labelledby="customized-dialog-title"
        open={openModal}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="Recruiter_Private_Skill_Modal">
          <DialogTitle className="admindailog_title_modal_recruitmentpartners">
            Add Agency
            <IconButton
              aria-label="close"
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                color: "grey",
              }}
              onClick={() => setOpenModal(false)}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </div>
        <DialogContent>
          <Typography gutterBottom>Recruitment Organization*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              options={recruiterData}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Recruitment Organization"
                />
              )}
              onChange={handleRecruiterName}
            />
          </FormControl>
          &nbsp;
          <Typography>Agency Type*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={agencyTypeOptions}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Agency Type"
                />
              )}
              onChange={handleAgencytype}
            />
          </FormControl>
          &nbsp;
          <Typography gutterBottom>Agency Name*</Typography>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              placeholder="Enter Agency Name"
              className="admin_textbox"
              onChange={handleName}
            />
          </FormControl>
          &nbsp;
          <Typography>Is Active*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={isActiveItems}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Status"
                />
              )}
              onChange={handleisActive}
            />
          </FormControl>
          &nbsp;
        </DialogContent>
        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={() => setOpenModal(false)}>
              Cancel
            </Button>

            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={createAgency}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div >
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
        <NotificationContainer />
      </Dialog>

      {/* ------------------Edit Agency------------------ */}
      <Dialog
        onClose={handleClosed}
        aria-labelledby="customized-dialog-title"
        open={modalIsOpenEdit}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="Recruiter_Private_Skill_Modal">
          <DialogTitle className="admindailog_title_modal_recruitmentpartners">
            Edit Agency
            <IconButton
              aria-label="close"
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                color: "grey",
              }}
              onClick={handleClosed}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </div>

        <DialogContent>
          <Typography gutterBottom>
            {/* Edit */}
            Recruitment Organization*
          </Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={recruiterData || ""}
              defaultValue={agencyInfo.recPartners}
              getOptionLabel={(option) => option.name}
              getOptionSelected={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Recruitment Organization"
                />
              )}
              onChange={handleRecruitmentPartnersClick}
            />
          </FormControl>
          &nbsp;
          <Typography gutterBottom>Agency Name*</Typography>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              placeholder="Enter Agency Name"
              className="admin_textbox"
              defaultValue={agencyInfo.agencyName}
              onChange={handleName}
            />
          </FormControl>
          &nbsp;
          <Typography>Agency Type*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={agencyTypeOptions}
              value={agencyInfo.selectedAgencyType || ""}
              getOptionLabel={(option) => option.name || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Agency Type"
                />
              )}
              onChange={handleAgencytype}
            />
          </FormControl>
          &nbsp;
          <Typography>Is Active*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={isActiveItems}
              value={agencyInfo.isActive === null ? null : (agencyInfo.isActive === "True" || agencyInfo.isActive === true ? "True" : "False")}

              getOptionLabel={(option) => option || ""}
              getOptionSelected={(option, value) => option === (value === true ? "True" : "False")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Status"
                />
              )}
              onChange={handleisActive}
            />
          </FormControl>
          &nbsp;
        </DialogContent>

        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={handleClosed}>
              Cancel
            </Button>
            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={editAgency}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div >
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
        <NotificationContainer />
      </Dialog>
    </>
  );
};

export default AgencyKendo;
